import { createTheme, PaletteMode, Theme } from '@mui/material';

declare module '@mui/material/styles' {
  interface Theme {
    palette: {
      primary: {
        main: string;
      };
      secondary: {
        main: string;
      };
      text: {
        primary: string;
        secondary: '#fff';
      };
      background: {
        default: string;
      };
      mode: PaletteMode;
    };
    typography: {
      fontFamily: string;
    };
  }
  // allow configuration using `createTheme`
  interface ThemeOptions {
    status?: {
      danger?: string;
    };
  }
}

export const getTheme = (mode: PaletteMode): Theme =>
  createTheme({
    palette: {
      primary: {
        main: mode === 'dark' ? '#141414' : '#00142D',
      },
      secondary: {
        main: mode === 'dark' ? '#656565' : '#fff',
      },
      text: {
        primary: mode === 'dark' ? '#fff' : '#000',
        secondary: '#fff',
      },
      background: {
        default: mode === 'dark' ? '#464646' : '#D0D0D0',
      },
      mode,
    },
    typography: {
      fontFamily: "'Nunito', sans-serif",
    },
    components: {
      MuiBreadcrumbs: {
        styleOverrides: {
          root: {
            color: mode === 'light' ? '#171717' : '#D0D0D0',

            '& .MuiBreadcrumbs-li': {
              cursor: 'pointer',
              color: mode === 'light' ? '#171717' : '#ffffff',
              '&:hover': {
                textDecoration: 'underline',
              },
            },
          },
        },
      },
      MuiSwitch: {
        styleOverrides: {
          root: {
            '& :checked': {
              color: 'red',
            },
          },
        },
      },
      MuiFormHelperText: {
        styleOverrides: {
          root: {
            color: mode === 'light' ? '#000' : '#fff',
          },
        },
      },
    },
  });
